<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-divider>秩序册信息</van-divider>
        <van-cell-group>
            <van-cell title="赛季" :value="pageData.sjname" />
            <van-cell title="赛区" :value="pageData.sqname" />
            <van-cell title="单位" :value="pageData.danwei" />
            <van-cell title="队伍名称" :value="pageData.mingcheng" />
            <!--
            <van-cell title="健康证明" v-if="pageData.jiankangpics.length>0" >
                <a :href="pic"  v-for="pic in pageData.jiankangpics">
                    <img style="max-height: 50px; margin-left: 10px;" :src="pic" />
                </a>
            </van-cell>
            <van-cell title="健康证明" v-else value="未上传" />-->
            <van-cell title="队伍合影" v-if="pageData.heying"  >
                <a :href="pageData.heying"><img style="max-height: 50px;" :src="pageData.heying" /></a>
            </van-cell>
            <van-cell title="队伍合影" v-else is-link >
                <el-upload
                        class="upload-demo"
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload = "onReadHeying"
                >
                    点击上传
                </el-upload> 
            </van-cell>
        </van-cell-group>
        <van-divider>人员信息</van-divider>
        <van-cell-group>
            <van-cell title="领队" v-for="user in pageData.lingdui_list" :value="user.name" :label="'身份证:'+user.num" />
        </van-cell-group>
        <van-cell-group>
            <van-cell :title="'教练员'+(index+1)" v-for="(user,index) in pageData.jiaolianyuan_list" :value="user.name" :label="'身份证:'+user.num" />
        </van-cell-group>
        <van-cell-group>
            <van-cell :title="'裁判员'+(index+1)" v-for="(user,index) in pageData.caipanyuan_list" :value="user.name" :label="'身份证:'+user.num"  />
        </van-cell-group>

        <van-cell-group>
            <van-cell :title="'运动员'+(index+1)" v-for="(user,index) in pageData.yundongyuan_list" :value="user.name" :label="'身份证:'+user.num"  />
        </van-cell-group>

        <van-divider>参赛人数</van-divider>
        <van-cell-group>
            <van-cell title="领队" value="1"  />
            <van-cell title="教练员" :value="pageData.jiaolianyuan_list.length" />
            <van-cell title="裁判员" :value="pageData.caipanyuan_list.length"  />
            <van-cell title="运动员" :value="pageData.yundongyuan_list.length"  />
            <van-cell title="总计" :value="pageData.member_total_count"  />
        </van-cell-group>
        <div style="padding: 20px;">
            <van-button type="primary"  size="large" v-if="pageData.confirm_1==2" @click.stop="save">信息无误 我已确认</van-button>
            <van-button   type="primary" size="large"  plain v-else >信息已确认</van-button>

            <van-button size="large" plain style="margin: 10px 0" @click.stop="edit">信息需要修改</van-button>


            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>
        <div class="mask" v-if="loadding">
            <van-loading type="spinner" color="white" />
        </div>
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog,Uploader
    } from 'vant';
    export default {
        name: 'saiConfirmDetail',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Uploader.name]: Uploader,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'jiankangpics' :[],
                    'lingdui_list' :[],
                    'yundongyuan_list' :[],
                    'jiaolianyuan_list' :[],
                    'caipanyuan_list' :[]
                },
                formData:{
                    'id' : this.$route.query.id,
                },
                showTime:false,
                timeField:'',
                showStation:false,
                stationField:'',
                loadding:false,
            }
        },
        mounted: function () {
            let that = this;
            document.title = "秩序册信息确认";
            this.$api.get('api/sai/confirmzhixucedetail', {
                'id':that.pageData.id
            }, r => {
                this.pageData = r.data;
            });

        },
        methods: {
            goIndex:function () {
                this.$router.push({
                    'name' :'saiConfirmManage',
                    'query':{}
                })
            },
            save:function () {
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '您确定信息准确无误吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                    },r=>{
                        that.$toast.fail(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });


            },
            edit:function () {
                let that = this;
                this.$router.push({
                    'name' :'saiConfirmQr1',
                    'query':{'id':that.pageData.id}
                })
            },
            onReadHeying:function (file) {
                console.log(file);
                let that = this;
                let formdata = new FormData();
                console.log(file);
                that.loadding = true;
                formdata.append('upfile',file);
                formdata.append('fieldName','upfile');
                formdata.append('user_id',that.pageData.userid);
                that.$api.upload('https://api.ccago.cn/core/attachment/ccaUploadImage',formdata, r => {
                    that.$message.success('操作成功');
                    that.$api.post('/wxapi_sai_updateheying', {
                        heying:r.data.url,
                        id:that.pageData.id
                    }, r2 => {
                        that.$message.success('操作成功');
                        that.$router.go(0);
                        that.loadding = false;
                    },r2=>{
                        that.$toast.fail(r2.msg);
                        that.loadding = false;
                    });
                },r=>{
                    that.$toast.fail(r.msg);
                    that.loadding = false;
                });
                return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
            }
        }
    }
</script>



// WEBPACK FOOTER //
// saiConfirmDetail1.vue?0a111c41